import { render, staticRenderFns } from "./mStories.vue?vue&type=template&id=6a93d5aa"
import script from "./mStories.vue?vue&type=script&lang=js"
export * from "./mStories.vue?vue&type=script&lang=js"
import style0 from "./mStories.vue?vue&type=style&index=0&id=6a93d5aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports